import React, {  } from 'react';
import {
    BrowserRouter as Router,
    Routes,
    Route
  } from 'react-router-dom';


import { PublicRoute } from './PublicRoute';
import { PrivateRoute } from './PrivateRoute';
import { DashboardRoutes } from './DashboardRoutes';
import { GeneralRoutes } from './GeneralRoutes';
   


export const AppRouter = () => {
    return (
        <Router>
            <div>
                <Routes>

                    <Route 
                        path="/*" 
                        element={
                        <PublicRoute>
                            <GeneralRoutes />
                        </PublicRoute>
                        }
                    />

                    <Route 
                        path="app/*" 
                        element={
                        <PrivateRoute>
                            <DashboardRoutes/>
                        </PrivateRoute>
                        }
                    />
                    
                </Routes>
            </div>
        </Router>
    )
}